import { makansafeConstants } from "@constants";

export function FoodGenerateAI(state = {}, action) {
    switch (action.type) {
        case makansafeConstants.GENERATE_AI_IDDSI_FOOD_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case makansafeConstants.GENERATE_AI_IDDSI_FOOD_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case makansafeConstants.GENERATE_AI_IDDSI_FOOD_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};

export function reportUsers(state = {}, action) {
    switch (action.type) {
        case makansafeConstants.REPORT_USERS_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case makansafeConstants.REPORT_USERS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case makansafeConstants.REPORT_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};

export function createIddsiAccount(state = {}, action) {
    switch (action.type) {
        case makansafeConstants.CREATE_IDDSI_ACCOUNT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case makansafeConstants.CREATE_IDDSI_ACCOUNT_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case makansafeConstants.CREATE_IDDSI_ACCOUNT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};

export function deactivateUserAccount(state = {}, action) {
    switch (action.type) {
        case makansafeConstants.DEACTIVATE_USER_ACCOUNT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case makansafeConstants.DEACTIVATE_USER_ACCOUNT_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case makansafeConstants.DEACTIVATE_USER_ACCOUNT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};